export default __webpack_public_path__ + "static/media/fund-hero-l.6e4f2d00.jpg";